function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { declMod } from '@yandex-lego/i-bem-react';
export default declMod({
  type: 'check'
}, {
  block: 'menu',
  willInit: function willInit(_ref) {
    var val = _ref.val;

    this.__base.apply(this, arguments);

    this.state.val = this._prepareVal(val);
    this.onClick = this.onClick.bind(this);
  },
  attrs: function attrs(_ref2) {
    var _ref2$tabIndex = _ref2.tabIndex,
        tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex;
    return _objectSpread({}, this.__base.apply(this, arguments), {
      'aria-multiselectable': 'true',
      role: 'listbox',
      tabIndex: tabIndex
    });
  },
  onClick: function onClick(e, val) {
    if (val !== null) {
      var oldVal = this.state.val;
      var newVal = oldVal.slice();
      var pos = oldVal.indexOf(val);
      pos === -1 ? newVal.push(val) : newVal.splice(pos, 1);
      this.setState({
        val: newVal
      });

      this._onChange(newVal, oldVal);
    }

    this.props.onClick && this.props.onClick(e, val);
  }
});